/**
 * PROTOTYPE route — throwaway mobile-width stand-in.
 * Question: does sheet + long-press feel native?
 *
 * Open: /prototype/contextual-tasks-mobile
 */
import type { MetaFunction } from '@remix-run/node'
import { ContextualTasksMobile } from '#app/components/prototype/contextual-tasks/ContextualTasksMobile'
import { usePrototypeState } from '#app/components/prototype/contextual-tasks/usePrototypeState'

export const meta: MetaFunction = () => [
	{ title: 'PROTOTYPE — Contextual tasks (mobile)' },
]

export default function PrototypeContextualTasksMobile() {
	const state = usePrototypeState()
	return <ContextualTasksMobile state={state} />
}
